// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
}

body {
  font-family: 'Poppins', sans-serif;
  background-color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/*
  AppBar
*/

.app-bar {
  padding: 8px 16px;
  background-color: white;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 10px;
  position: sticky;
  top: 0;
  z-index: 99;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.app-bar .app-bar__menu {
  display: flex;
  align-items: center;
}

.app-bar .app-bar__menu button {
  background-color: transparent;
  border: none;
  font-size: 18px;
  padding: 8px;
  cursor: pointer;
}

.app-bar .app-bar__brand {
  display: flex;
  align-items: center;
}

.app-bar .app-bar__brand h1 {
  color: #db0000;
  text-transform: uppercase;
  font-size: 22px;
  user-select: none;
}

.app-bar .app-bar__navigation {
  position: absolute;
  top: 50px;
  left: -180px;
  width: 150px;
  transition: all 0.3s;
  padding: 8px;
  background-color: white;
  overflow: hidden;
}

.app-bar .app-bar__navigation.open {
  left: 0;
}

.app-bar .app-bar__navigation ul li a {
  display: inline-block;
  text-decoration: none;
  color: black;
  padding: 8px;
  margin-bottom: 5px;
  width: 100%;
}

/*
  Main Content
*/

main {
  padding: 32px;
  flex: 1;
}

.content {
  margin: 0 auto;
  min-height: 100%;
}

.content .content__heading {
  font-weight: normal;
}


/*
  Movies
*/

.movies {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin: 32px 0;
}

/*
  Movie Item
*/

.movie-item {
  width: 100%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.movie-item__header {
  position: relative;
}

.movie-item .movie-item__header .movie-item__header__poster {
  width: 100%;
}

.movie-item .movie-item__header .movie-item__header__rating {
  position: absolute;
  padding: 8px;
  bottom: 20px;
  left: 0;
  display: inline-block;
  background-color: black;
  color: white;
}

.movie-item .movie-item__header .movie-item__header__rating .movie-item__header__rating__score {
  margin-left: 10px;
}

.movie-item .movie-item__content {
  padding: 16px;
}

.movie-item .movie-item__content h3 {
  margin: 0 0 10px 0;
}

.movie-item .movie-item__content h3 a {
  color: #db0000;
  text-decoration: none;
}

.movie-item .movie-item__content p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  -webkit-box-orient: vertical;
}

/*
  Movie
*/

.movie {
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px 16px;
}

.movie .movie__poster {
  width: 100%;
  max-width: 400px;
}

.movie .movie__info h4 {
  margin: 8px 0;
}

/*
  Footer
*/

footer {
  padding: 16px;
}

footer #footerTools {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}

footer p {
  margin-top: 16px;

  text-align: center;
  color: #aaaaaa;
}

footer p a {
  color: #db0000;
  text-decoration: none;
}

/*
  Like
*/

.like {
  font-size: 18px;
  position: fixed;
  bottom: 16px;
  right: 16px;
  background-color: #db0000;
  color: white;
  border: 0;
  border-radius: 50%;
  width: 55px;
  height: 55px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/*
  Button
*/

.btn {
  display: inline-block;
  padding: 12px 24px;
  background-color: #DB0000;
  border: 1px solid #770000;
  border-radius: 4px;
 
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
 
  cursor: pointer;
  transition: .15s ease-in-out;
}

.btn:hover {
  background-color: #DB0000BB;
}

.btn:active {
  background-color: #DB0000DD;
}

.btn:focus-visible {
  outline: 3px solid #DB000055;
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;CAEC;;AAED;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;;CAEC;;AAED;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;CAEC;;AAED;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,cAAc;AAChB;;AAEA;;CAEC;;AAED;EACE,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,OAAO;EACP,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB,EAAE,4BAA4B;EACnD,4BAA4B;AAC9B;;AAEA;;CAEC;;AAED;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;CAEC;;AAED;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;;EAEhB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;CAEC;;AAED;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;CAEC;;AAED;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;;EAElB,gBAAgB;EAChB,eAAe;EACf,cAAc;;EAEd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n}\n\nbody {\n  font-family: 'Poppins', sans-serif;\n  background-color: white;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/*\n  AppBar\n*/\n\n.app-bar {\n  padding: 8px 16px;\n  background-color: white;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 10px;\n  position: sticky;\n  top: 0;\n  z-index: 99;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n}\n\n.app-bar .app-bar__menu {\n  display: flex;\n  align-items: center;\n}\n\n.app-bar .app-bar__menu button {\n  background-color: transparent;\n  border: none;\n  font-size: 18px;\n  padding: 8px;\n  cursor: pointer;\n}\n\n.app-bar .app-bar__brand {\n  display: flex;\n  align-items: center;\n}\n\n.app-bar .app-bar__brand h1 {\n  color: #db0000;\n  text-transform: uppercase;\n  font-size: 22px;\n  user-select: none;\n}\n\n.app-bar .app-bar__navigation {\n  position: absolute;\n  top: 50px;\n  left: -180px;\n  width: 150px;\n  transition: all 0.3s;\n  padding: 8px;\n  background-color: white;\n  overflow: hidden;\n}\n\n.app-bar .app-bar__navigation.open {\n  left: 0;\n}\n\n.app-bar .app-bar__navigation ul li a {\n  display: inline-block;\n  text-decoration: none;\n  color: black;\n  padding: 8px;\n  margin-bottom: 5px;\n  width: 100%;\n}\n\n/*\n  Main Content\n*/\n\nmain {\n  padding: 32px;\n  flex: 1;\n}\n\n.content {\n  margin: 0 auto;\n  min-height: 100%;\n}\n\n.content .content__heading {\n  font-weight: normal;\n}\n\n\n/*\n  Movies\n*/\n\n.movies {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin: 32px 0;\n}\n\n/*\n  Movie Item\n*/\n\n.movie-item {\n  width: 100%;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.movie-item__header {\n  position: relative;\n}\n\n.movie-item .movie-item__header .movie-item__header__poster {\n  width: 100%;\n}\n\n.movie-item .movie-item__header .movie-item__header__rating {\n  position: absolute;\n  padding: 8px;\n  bottom: 20px;\n  left: 0;\n  display: inline-block;\n  background-color: black;\n  color: white;\n}\n\n.movie-item .movie-item__header .movie-item__header__rating .movie-item__header__rating__score {\n  margin-left: 10px;\n}\n\n.movie-item .movie-item__content {\n  padding: 16px;\n}\n\n.movie-item .movie-item__content h3 {\n  margin: 0 0 10px 0;\n}\n\n.movie-item .movie-item__content h3 a {\n  color: #db0000;\n  text-decoration: none;\n}\n\n.movie-item .movie-item__content p {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 4; /* number of lines to show */\n  -webkit-box-orient: vertical;\n}\n\n/*\n  Movie\n*/\n\n.movie {\n  margin: 0 auto;\n  width: 100%;\n  max-width: 800px;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 18px 16px;\n}\n\n.movie .movie__poster {\n  width: 100%;\n  max-width: 400px;\n}\n\n.movie .movie__info h4 {\n  margin: 8px 0;\n}\n\n/*\n  Footer\n*/\n\nfooter {\n  padding: 16px;\n}\n\nfooter #footerTools {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n}\n\nfooter p {\n  margin-top: 16px;\n\n  text-align: center;\n  color: #aaaaaa;\n}\n\nfooter p a {\n  color: #db0000;\n  text-decoration: none;\n}\n\n/*\n  Like\n*/\n\n.like {\n  font-size: 18px;\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  background-color: #db0000;\n  color: white;\n  border: 0;\n  border-radius: 50%;\n  width: 55px;\n  height: 55px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/*\n  Button\n*/\n\n.btn {\n  display: inline-block;\n  padding: 12px 24px;\n  background-color: #DB0000;\n  border: 1px solid #770000;\n  border-radius: 4px;\n \n  font-weight: 500;\n  font-size: 16px;\n  color: #ffffff;\n \n  cursor: pointer;\n  transition: .15s ease-in-out;\n}\n\n.btn:hover {\n  background-color: #DB0000BB;\n}\n\n.btn:active {\n  background-color: #DB0000DD;\n}\n\n.btn:focus-visible {\n  outline: 3px solid #DB000055;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
